module.exports = __webpack_public_path__ + "img/tooltip_03-VALLONE_FINISH_HST_K25_LEGNO-AUTUMN.431ec10f.jpg";